import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n=new VueI18n({
    locale:localStorage.getItem('languageSet')||'zh',   //从localStorage里获取用户中英文选择，没有则默认中文
    messages:{
        'zh':require('./zh/zh'),
        'en':require('./en/en')
    }
})
export default i18n;


// WEBPACK FOOTER //
// ./src/components/work/language/language.js